export const RollLocationDisplay = (number) => {
  const status = number;
  switch (status) {
    case 0:
      return "Warehouse";
    case 1:
      return "Arsoma";
    case 2:
      return "Viva";
    case 4:
      return "In Order";
    default:
      console.log(`Sorry, no order status here`);
  }
};
